import getUri, { getPageHelpUri } from '../../../utils/getUri';

export const constants = {
    inputTypes: {
        label: 'label',
        multiSelect: 'multiSelect',
        number: 'number',
        singleSelect: 'singleSelect',
        string: 'string',
        unconstrainedMultiSelect: 'unconstrainedMultiSelect',
    },
    parameterTypes: {
        default: 'default',
        dynamicList: 'dynamicList',
    },
    units: {
        seconds: 'seconds',
        minutes: 'minutes',
        timeOfDay: 'timeOfDay',
        percentage: 'percentage',
        bags: 'bags',
    },
};

export const uriConstants = {
    configurationAuditUri: getUri('ConfigurationAudit'),
    kpiConfigurationUri: getUri('KpiConfiguration'),
    pageHelpUri: (onlineHelpId) => getPageHelpUri({ onlineHelpId }),
    selectOptionsUri: getUri('SelectOptionApi/GetCriteriaValues'),
    createNotificationUri: getUri(
        'ManageNotificationInstance/CreateNotification'
    ),
    getNotificationInstancesUri: getUri('ManageNotificationInstance/GetAll'),
    deleteNotificationInstanceUri: getUri('ManageNotificationInstance/Delete'),
    cloneNotificationInstanceUri: getUri('ManageNotificationInstance/Clone'),
};
